module.exports = __webpack_public_path__ + "media/en_au_s4_Mason.ae04fbf1.mp3";